let CustomComponents = require("@client/components/CustomComponents");

const importer = (defaultComponent, customComponent) => {
    return CustomComponents[customComponent] || defaultComponent;
}

export { importer };
